import ApiService from './api.service'
import { AuthenticationError } from "@/services/user.service";

const main = '/vacancy'
const question = '/question'
const vacantAriza = '/employee-app-candidate'
export default {
    getSeconds(id) {
        return ApiService.get(`/employee/check-employee-status/${id}`)
    },
    getVacantById(id) {
        return ApiService.get(`/employee/check-employee-status/${id}`)
    },
    async getTestByVacancyId(id) {
        return ApiService.get(`/employee/test-list/${id}`)
    },
    submitTestOffer(id) {
        return ApiService.get(`/employee/make-testOffer-submitted/${id}`)
    },
    getArizaPdf: async function (id, id2) {
        return ApiService.post(`${vacantAriza}/get-application-pdf/${id}/${id2}`)
    },
    getPassportSeria: async function (data) {
        return ApiService.post(`${main}/passport-serial-list`, data)
    },
    updatePasswordPinfl: async function (data) {
        return ApiService.post(`${main}/change-info`, data)
    },
    getVacancy: async function (data) {
        return ApiService.get(`${main}/vacancy-list-byAnnouncementId/${data}`)
    },
    selectVacancy: async function (data) {
        return ApiService.put(`/employee/connect/${data}`)
    },
    getEmployeeByStaff: async function (data) {
        return ApiService.put(`/employee/connect/${data.id}`, data.params)
    },
    getAnnoucement: async function (data) {
        return ApiService.post(`${main}/announcement-list`, data)
    },
    getById(data) {
        return ApiService.get(`${main}/announcement-byId/${data}`)
    },

    sendDocument() {
        return ApiService.post(`/employee/submit-status`)
    },

    //QUESTION
    getTestList: async function (data, params) {
        return ApiService.post(`${question}/list?questionTypeId=${data.typeId || ''}&search=${data.search}`, params)
    },
    getListDep: async function () {
        return ApiService.get(`${question}/legal-department`)
    },
    createQuestion: async function (data) {
        return ApiService.post(`${question}/create`, data)
    },
    deleteQuestion: async function (data) {
        return ApiService.delete(`${question}/delete/${data}`)
    },
    updateQuestion: async function (data) {
        return ApiService.post(`${question}/update`, data)
    },


    getRandomTestList: async function () {
        return ApiService.get(`/employee/test-list`)
    },
    sendAnswer: async function (id) {
        return ApiService.get(`employee/test-list-finish/${id}`)
    },
    getTestResult: async function (id, vId) {
        return ApiService.get(`employee/test-result-byEmployeeId/${id}/${vId}`)
    },
    testSubmit(data) {
        return ApiService.post(`/employee/test-submit`, data)
    },
    getAnswerDoc({ employeeId, staffListVacancyId }) {
        return ApiService.get(`employee/view-cancel-reason/${employeeId}/${staffListVacancyId}`)
    },
    viewPdf(data) {
        return ApiService.post(`employee/view-pdf`, data)
    }

}
